import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _parseInt from 'lodash/parseInt';
import _isEmpty from 'lodash/isEmpty';
// Models
import { sortActions } from 'models/scenario';
// Custom
import { deviceDataShape, installationLogScenarioLogDataShape } from 'constants/PropTypesShapes';
import Callout from 'components/misc/Callout';
import ScenarioLogExecInputCondition from './ScenarioLogExecInputCondition';
import ScenarioLogExecInputTrigger from './ScenarioLogExecInputTrigger';
import ScenarioLogExecConflict from './ScenarioLogExecConflict';
import ScenarioLogExecActionItem from './ScenarioLogExecActionItem';

const ScenarioLogExec = ({ scenarioLog, device }) => {
  const { status, exec, success_condition: successCondition } = scenarioLog;
  // Get status
  const isErrorInputCondition = status === 'error_input_contition';
  // Get input trigger
  const execInputTrigger = exec.input_trigger;
  // Get input condition
  const execInputCondition = exec.input_condition;
  // Build conflicts
  const conflicts = _map(exec.conflicts, (value, key) => ({ delay: _parseInt(key), idRelay: _parseInt(value) }));
  // Get actions
  const actions = sortActions(exec.actions);

  return (
    <div className="w-100 pt-3">
      <Callout helpTooltip="tooltip.scenarioLogSuccessCondition">
        <LocalizedMessage id={`scenario.successCondition.${successCondition}`} />
      </Callout>
      {execInputTrigger && (
        <div className="my-2">
          <Callout>
            <ScenarioLogExecInputTrigger execInputTrigger={execInputTrigger} device={device} />
          </Callout>
        </div>
      )}
      {execInputCondition && (
        <div className="my-2">
          <Callout severity={isErrorInputCondition ? 'warning' : 'info'}>
            <ScenarioLogExecInputCondition isErrorInputCondition={isErrorInputCondition} execInputCondition={execInputCondition} device={device} />
          </Callout>
        </div>
      )}
      {conflicts && !_isEmpty(conflicts) && (
        <div className="my-2">
          <Callout severity="warning">
            <div>
              <LocalizedMessage id="info.scenarioExecConflicts" />
              {_map(conflicts, (conflict) => (
                <ScenarioLogExecConflict
                  key={`${conflict.delay}-${conflict.idRelay}`}
                  conflict={conflict}
                  device={device}
                />
              ))}
            </div>
          </Callout>
        </div>
      )}
      {_map(actions, (action, index) => (
        <div key={_toString(index)}>
          <ScenarioLogExecActionItem action={action} device={device} />
        </div>
      ))}
    </div>
  );
};

ScenarioLogExec.propTypes = {
  scenarioLog: installationLogScenarioLogDataShape.isRequired,
  device: deviceDataShape.isRequired,
};

module.exports = ScenarioLogExec;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/logs/ScenarioLogExec.js